/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=0c44c806"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0c44c806&lang=stylus"

import exportComponent from "D:\\junwei\\jwSPDwx\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__